import { Autocomplete, Box, Modal, TextField } from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from 'react';

import "../modal.scss"


const ContactAddModal = (props) => {
	const [open, setOpen] = useState(props.open);

	const [selectedContact, setSelectedContact] = useState();
	const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
	const [role, setRole] = useState();
	const [title, setTitle] = useState([]);
	const [email, setEmail] = useState();
	const [phoneNumber, setPhoneNumber] = useState();
	const [company, setCompany] = useState();

    const [existingContacts, setExistingContacts] = useState(props.allContacts)

	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open])

	useEffect(() => {
		if (props.selectedContact) {
			setSelectedContact(props.selectedContact)
		}
	},[props.selectedContact])
	useEffect(() => {
		if (!selectedContact) return;

        setFirstName(selectedContact.name.first_name)
        setLastName(selectedContact.name.last_name)
        setCompany(selectedContact.company)
        setEmail(selectedContact.email)
        setPhoneNumber(selectedContact.phone_number)
		setTitle(selectedContact.title)
        setRole(selectedContact.role)

		//Fill this in when we get to edits
        //setIsEdit(true);

	}, [selectedContact])

    useEffect(() => {
        if (props.allContacts) {
            let contacts = []
            props.allContacts.forEach(c => {
                let decoratedContact = Object.assign({}, c);
                let label = ""
                if (c.name.first_name && c.name.last_name) label += c.name.first_name + " " + c.name.last_name;
                else if (c.name.first_name) label += c.name.first_name;

                if (c.company) label += label.length > 0 ? " (" + c.company + ")" : c.company;
                decoratedContact.label = label;
                contacts.push(decoratedContact);
            });
            setExistingContacts(contacts);
        }
    }, [props.allContacts])

	const handleClose = () => props.closeCallback();

	const handleFirstNameChange = (event) => setFirstName(event.target.value);
	const handleLastNameChange = (event) => setLastName(event.target.value);
	const handleCompanyChange = (event) => setCompany(event.target.value);
	const handleTitleChange = (event) => setTitle(event.target.value);
	const handleEmailChange = (event) => setEmail(event.target.value);
	const handlePhoneNumberChange = (value) => setPhoneNumber(value);

  	async function handleSubmit(event) {
		event.preventDefault();
		setIsSubmitting(true);

        if (selectedContact) {
            await props.associateContact(email);
        } else {
            const contact = await props.addContact({
                "name": {
                    "first_name": firstName,
                    "last_name": lastName
                },
                "email": email,
                "phone_number": phoneNumber,
                "title": title,
                "role": role
            });
            await props.associateContact(contact.email);
        }
		props.onSubmit();
        setIsSubmitting(false);
        handleClose();
	}

    return (
    	<Modal sx={{border: '0px'}} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
			<Box
				sx={{
					position: 'absolute',
					display: 'flex',
					flexDirection: 'column',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: 350,
					bgcolor: 'background.paper',
					border: '1px solid #CCC',
					borderRadius: 3,
					boxShadow: 24,
					maxHeight: 700,
					overflowY: 'scroll',
					p: 4,
				}}
			>
            <form onSubmit={handleSubmit}>
				<Box flexDirection="column" display="flex">
					<div className="row-form-field">
						<Autocomplete
							id="contact"
							options={existingContacts || []}
							getOptionLabel={(option) => { return option.label }}
							renderInput={(params) => <TextField {...params} label="Connect existing contact" variant="outlined" size="small" />}
							onChange={(event, newValue) => {
								setSelectedContact(newValue)
							}}
						/>
					</div>
					<div className="row-form-field multi-field">
						<TextField id="firstName" label="First Name" variant="outlined" size="small" value={firstName || ''} fullWidth onChange={handleFirstNameChange} />
                        <TextField id="lastName" label="Last Name" variant="outlined" size="small" value={lastName|| ''} fullWidth onChange={handleLastNameChange} />
					</div>
                    <div className="row-form-field">
                        <TextField id="company" label="Company" variant="outlined" size="small" value={company || ''} fullWidth onChange={handleCompanyChange} />
                    </div>
                    <div className="row-form-field">
                        <TextField id="title" label="Title" variant="outlined" size="small" value={title || ''} fullWidth onChange={handleTitleChange} />
                    </div>
                    <div className="row-form-field">
                        <TextField id="email" type="email" label="Email Address" variant="outlined" size="small" value={email || ''} required fullWidth onChange={handleEmailChange} />
                    </div>
                    <div className="row-form-field">
                        <MuiPhoneNumber id="phone" label="Phone Number" defaultCountry={'us'} variant="outlined" size="small" value={phoneNumber || ''} required fullWidth onChange={handlePhoneNumberChange} />
                    </div>
                    <div className="row-form-field">
						<Autocomplete
							id="role"
							options={props.contactRoles || []}
							renderInput={(params) => <TextField {...params} required label="Role" variant="outlined" size="small" />}
                            value={role || ''}
							onChange={(event, newValue) => {
								setRole(newValue)
							}}
						/>
					</div>

                    <div className="row-button-container">
                        <LoadingButton
                            variant="contained"
                            loading={isSubmitting}
                            type="submit"
                            sx={{position: "absolute", right: 0, backgroundColor: "#003e51"}}>
                                { selectedContact ? "Associate Contact" :  "Add Contact" }
                        </LoadingButton>
                    </div>
              	</Box>
            </form>
        </Box>
    </Modal>
  )
};

export default ContactAddModal;
